var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPawDuotone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fad",
    "data-icon": "paw",
    className: "svg-inline--fa fa-paw fa-w-16",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fa-group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fa-secondary",
    fill: "#fff",
    d: "M448 424.26c0 34.9-26.81 55.75-71.74 55.75-48.41 0-80.75-25.08-120.26-25.08-39.17 0-71.42 25.08-120.26 25.08C90.82 480 64 459.16 64 424.26 64 346.77 176.6 224 256 224s192 122.77 192 200.26z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "fa-primary",
    fill: "#fff",
    d: "M474.84 161.28c-29.12-7-61.15 15.48-71.56 50.13s4.77 68.38 33.89 75.34 61.15-15.48 71.56-50.13-4.73-68.38-33.89-75.34zm-437.67 0C8.05 168.23-7.12 202 3.28 236.61s42.44 57.09 71.56 50.13 44.29-40.69 33.89-75.34-42.44-57.09-71.56-50.13zm113.4-127.89c-30.94 8.14-46.42 49.94-34.58 93.36s46.53 72 77.46 63.87 46.42-49.94 34.55-93.36-46.49-72.01-77.43-63.87zm210.88 0c-30.94-8.15-65.62 20.45-77.45 63.87s3.64 85.22 34.58 93.36 65.62-20.45 77.46-63.87-3.65-85.21-34.59-93.36z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawDuotone);
export default __webpack_public_path__ + "static/media/paw-duotone.6069ef64009ceb08d1a61fe5e2c78d45.svg";
export { ForwardRef as ReactComponent };